/*
 *
 * Producer -- Alvin
 * Time -- 2018/7/6
 * Function -- Entry for creating wrappered sensor
 *
 */
import sensorFieldsIntegrationCreator from './sensorFieldsIntegrationCreator';
import { sensorGoCreator } from './globalSensorHandler';
import { typeofArray, typeofObject } from './utils/typeofUtil';
import warning from './utils/warning';
import { sensorCheck } from './globalSensorHandler'
function paramsCheck(param, paramName, type) {
    let typeCheck = {
        object: typeofObject,
        array: typeofArray
    };
    if (!typeCheck[type](param)) {
        warning(
            `Sensor Warning: Argument '${paramName}' required to function 'WrappedSensor' must be '${type}' ` +
            `but got a ${typeof param}`
        );
        return false;
    }
    return true;
}

export default function initialize(
    eventFieldsMap,
    fields,
    autoCompleteEnhancer = {},
    options = {}
) {
    if (
        !(paramsCheck(eventFieldsMap, 'eventFieldsMap', 'object') &&
            paramsCheck(fields, 'fields', 'array') &&
            paramsCheck(autoCompleteEnhancer, 'autoCompleteEnhancer', 'object')
        )
    ) return {};
    let { sensorIntegrator, SensorIntegration ,fieldsConvertion } = sensorFieldsIntegrationCreator({ eventFieldsMap, fields, autoCompleteEnhancer, options });
    let _sensorStatus = 'notInitialized';
    return {
        Integration: SensorIntegration,
        integrator: sensorIntegrator,
        go: function (eventKey, value, sensorKey) {
            let combinedValue = sensorIntegrator(eventKey, value);
            if (!combinedValue) return;
            let sensorGo = sensorGoCreator(sensorKey);
            if (typeof sensorGo === 'function') {
                sensorGo(eventKey, combinedValue);
            }
        },
        test: function () {
            Object.keys(eventFieldsMap).forEach(event => {
                sensorIntegrator(event, {});
            });
        },
        push:function(sensorKey,value,type){
            let sensorGo = sensorGoCreator(sensorKey);
            let combinedValue = value && fieldsConvertion(value,type)
            if (typeof sensorGo === 'function' ) {
                sensorGo(combinedValue);
            }
        },
        other:function(sensorKey,value){
            let sensorGo = sensorGoCreator(sensorKey);
            if (typeof sensorGo === 'function' ) {
                sensorGo( value);
            }
        },
        initial: function (value = {}) {
            if (_sensorStatus === 'notInitialized') {
               
                let sensorGo = sensorGoCreator('registerPage');
                if (typeof sensorGo !== 'function') return;

                let combinedValue = sensorIntegrator('registerPage', value);
                
                if (!combinedValue) return;

                sensorGo(combinedValue);
                // sensorGoCreator 
                // sensorGoCreator('quick')('autoTrack')
                sensorGo && (_sensorStatus = 'initialized')
            }
        }
    };
}



// WEBPACK FOOTER //
// ./common/Utils/sensor-wrapper/src/index.js